import { render, staticRenderFns } from "./index-tips.vue?vue&type=template&id=85ccdc88&scoped=true"
import script from "./index-tips.vue?vue&type=script&lang=js"
export * from "./index-tips.vue?vue&type=script&lang=js"
import style0 from "./index-tips.vue?vue&type=style&index=0&id=85ccdc88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ccdc88",
  null
  
)

export default component.exports